'use strict';
const moment = require('moment');
const angular = require('angular');
const {isNumber, isString, isUndefined, lowercase} = angular;

module.exports = [
  CsvImportService];

function CsvImportService() {

  this.mapWithHeaders = mapWithHeaders;
  this.parseNumber = parseNumber;
  this.parseDate = parseDate;
  this.parseBoolean = parseBoolean;


  // TODO: incorporate 'requires' logic...
  function mapWithHeaders(parsedData, headers) {
    if (parsedData.errors && parsedData.errors.length > 0) return;
    if (parsedData.data.length < 2) {
      parsedData.errors = ["Found less than 2 rows of data. Please include the headers and at least one item to create."];
      return;
    }

    parsedData.errors = [];

    // Map the headers
    var headerRow = parsedData.data[0];
    var headerMap = new Array(headerRow.length);
    for (var i = 0, length = headerRow.length; i < length; i++) {
      headerMap[i] = headerRow[i].toLowerCase().replace(/\s/g, "_");

      if (!(headerMap[i] in headers)) {
        parsedData.errors.push("Found invalid header \"" + headerRow[i] + "\". Please correct or remove it.");
      }
    }

    if (parsedData.errors.length > 0) return;

    // map the data to the corresponding header
    // note: this starts at 1 to skip the header row; correspondingly, the new array has 1 less item
    var dataMap = new Array(parsedData.data.length - 1);
    for (i = 1, length = parsedData.data.length; i < length; i++) {
      dataMap[i - 1] = {num: i + 1}; // stores human friendly row number: starts with 1, not 0
      for (var k = 0, len = parsedData.data[i].length; k < len; k++) {
        if (!headers[headerMap[k]].excluded) {
          dataMap[i - 1][headerMap[k]] = parsedData.data[i][k].trim();

          if (headers[headerMap[k]].type === 'string' && headers[headerMap[k]].inList) {
            dataMap[i - 1][headerMap[k]] = verifyInList(parsedData, headerMap[k], dataMap[i - 1][headerMap[k]], headers[headerMap[k]].inList);

            if (parsedData.errors && parsedData.errors.length) return null; // error detected. escape loop

          } else if (headers[headerMap[k]].type === 'email') {
            dataMap[i - 1][headerMap[k]] = verifyEmail(parsedData, headerMap[k], dataMap[i - 1][headerMap[k]]);

            if (parsedData.errors && parsedData.errors.length) return null; // error detected. escape loop

          } else if (headers[headerMap[k]].type === 'number' && dataMap[i - 1][headerMap[k]]) {
            dataMap[i - 1][headerMap[k]] = parseNumber(dataMap[i - 1][headerMap[k]]);
          } else if (headers[headerMap[k]].type === 'boolean' && dataMap[i - 1][headerMap[k]]) {
            dataMap[i - 1][headerMap[k]] = parseBoolean(dataMap[i - 1][headerMap[k]]);
          } else if (headers[headerMap[k]].type === 'date' && dataMap[i - 1][headerMap[k]]) {
            dataMap[i - 1][headerMap[k]] = parseDate(dataMap[i - 1][headerMap[k]], false); // TODO: impl dependency requirement
          }
        }
      }
    }

    return dataMap;
  }

  function verifyInList(parsedData, header, value, list) {
    var sanitizedValue = (value || '').toLowerCase();
    for (var i = 0, length = list.length; i < length; i++) {
      if (sanitizedValue === list[i].toLowerCase()) return list[i];
    }

    // TODO(i18n)
    if (!parsedData.errors) parsedData.errors = [];
    var error = header + ' must be one of ' + list.toString();

    parsedData.errors.push(error);
    return null;
  }

  function verifyEmail(parsedData, header, value) {
    if (isString(value) && value.indexOf('@') > -1) return value;

    // TODO(i18n)
    if (!parsedData.errors) parsedData.errors = [];
    var error = header + ' must be a valid email address';

    parsedData.errors.push(error);
    return null;
  }

  function parseNumber(input) {
    if (isUndefined(input)) return null;

    try {
      var out = parseFloat(input);

      return isNumber(out) ? out : null;
    } catch (e) {
      return null;
    }
  }

  function parseDate(input) {
    if (isUndefined(input) || input === '' || input === null) return null;
    if (input === '-') return input;
    var dateTime = moment(input, 'L LT');
    var date = moment(input, 'L');

    if (dateTime.valueOf() === date.valueOf()) {
      dateTime.hours(12);

      return dateTime.valueOf();
    } else {
      return dateTime.valueOf();
    }
  }

  function parseBoolean(input) {
    if (input === true) return true;
    if (input === false) return false;
    if (isString(input)) return lowercase(input) === 'true';
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/csv-imports-exports/CsvImportService.js